import { Link } from "react-router-dom";
import { Palette, Mail, Home } from "lucide-react";

export default function Footer(){
    return (
        <footer className="bg-gradient-to-b from-gray-900 to-black text-white py-12 mt-20 border-t-4 border-orange-500">
            <div className="max-w-7xl mx-auto px-6">
                <div className="flex flex-col md:flex-row justify-between items-center gap-8">
                    <div className="flex items-center gap-3">
                        <Palette className="accent-orange" size={40} />
                        <div>
                            <h3 className="font-bold text-xl">Galerie Deveau</h3>
                            <p className="text-gray-400 text-sm">L'art en toute authenticité</p>
                        </div>
                    </div>
                    
                    <nav>
                        <ul className="flex gap-8 items-center font-medium">
                            <li className="flex items-center gap-2">
                                <Home size={18} className="accent-orange" />
                                <Link to='/' className="hover-accent-orange transition-colors">Accueil</Link>
                            </li>
                            <li className="flex items-center gap-2">
                                <Palette size={18} className="accent-orange" />
                                <Link to='/collection' className="hover-accent-orange transition-colors">Collection</Link>
                            </li>
                            <li className="flex items-center gap-2">
                                <Mail size={18} className="accent-orange" />
                                <Link to='/contact' className="hover-accent-orange transition-colors">Contact</Link>
                            </li>
                        </ul>
                    </nav>
                </div>
                
                <div className="mt-8 pt-8 border-t border-gray-800 text-center">
                    <p className="text-gray-400 text-sm">
                        © {new Date().getFullYear()} Galerie Deveau - Toutes les œuvres sont protégées par le droit d'auteur
                    </p>
                    <a 
                        className="mt-2 inline-block text-gray-500 hover-accent-orange transition-colors text-xs" 
                        href="https://github.com/Lukas-bt"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Développé avec 🎨 par Lukas
                    </a>
                </div>
            </div>
        </footer>
    );
}